import { ReactNode } from "react";
// import styled from "styled-components";
import { LoadingSpinner } from "./LoadingSpinner";
import clsx from "clsx";

type ButtonProps = {
  children: ReactNode,
  onClick?: () => void
  upperCased?: boolean
  submit?: boolean
  disabled?: boolean
  secondary?: boolean
  bolder?: boolean
  isLoading?: boolean
  style?: React.CSSProperties
  className?: string
}

export const Button = ({
  children,
  onClick,
  upperCased,
  submit,
  disabled,
  secondary,
  bolder,
  isLoading,
  style,
  className,
}: ButtonProps) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={onClick}
      disabled={isDisabled}
      style={style}
      className={clsx(
        // Base
        "block mx-auto py-3 px-6 rounded-[58px]",
        "shadow-[0px_4px_4px_#00000017]",
        "text-center leading-normal border-2",
        "transition-colors duration-200",
        "cursor-pointer",

        // Typography
        bolder ? "font-black" : "font-medium",
        upperCased && "uppercase",

        // Primary variant
        !secondary && [
          "bg-[var(--color-primary-1)]",
          "border-[var(--color-primary-1)]",
          "text-white",
          "hover:bg-white",
          "hover:text-[var(--color-primary-1)]",
        ],

        // Secondary variant
        secondary && [
          "bg-transparent",
          "border-transparent",
          "text-[var(--color-primary-1)]",
          "hover:bg-white",
        ],

        // Disabled state
        isDisabled &&
          (secondary
            ? "text-gray-400 border-gray-300 cursor-not-allowed hover:bg-transparent"
            : "bg-gray-300 border-gray-300 text-white cursor-not-allowed hover:bg-gray-300 hover:text-white"),
        className,
      )}
    >
      {isLoading ? (
        <LoadingSpinner sm color="white" />
      ) : (
        children
      )}
    </button>
  );
};

/* const StyledButton = styled.button<{ $upperCased: boolean, $secondary: boolean, $bolder: boolean}>`
  box-shadow: 0px 4px 4px 0px #00000017;
  background-color: ${({ theme, $secondary }) => $secondary ? 'transparent' : theme.colors.primary1};
  border: ${({ theme, $secondary }) => $secondary ? 'none' : theme.colors.primary1 + ' 2px' + ' solid'};
  color: ${({ theme, $secondary }) => $secondary ? theme.colors.primary1 : 'white'};
  display: block;
  font-weight: ${({ $bolder }) => $bolder ? '900' : '500'};
  border-radius: 58px;
  line-height: normal;
  margin: auto;
  padding: 12px 24px;
  text-align: center;
  text-transform: ${(props) => props.$upperCased ? 'uppercase' : 'none'};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.primary1};
    background-color: white;
  }
  &:disabled {
    background-color: ${({ $secondary }) => $secondary ? 'transparent' : 'lightgray'};
    color: ${({ $secondary }) => $secondary ? 'lightgray' : 'white'};
    border-color: ${({ $secondary }) => $secondary ? 'lightgray' : 'transparent'};
  }
`

export const Button = ({
  children,
  onClick,
  upperCased,
  submit,
  disabled,
  secondary,
  bolder,
  isLoading,
}: ButtonProps) => {
  return (
    <StyledButton
      type={submit ? 'submit' : 'button'}
      onClick={onClick}
      $upperCased={!!upperCased}
      disabled={disabled || isLoading}
      $secondary={!!secondary}
      $bolder={!!bolder}
    >
      {
        isLoading
        ? <LoadingSpinner sm color="white"/>
        : children
      }
    </StyledButton>
  )
} */
